import { useLingui } from "@lingui/react";
import {
  ApiDatafanPipeline,
  EApiDatafanProgressType,
  IApiDatafanPipelineExport,
} from "@smp/api";
import { useQuery, useQueryClient, UseQueryOptions } from "react-query";

const KEY = "datafan.pipeline.export";

export const useQueryDatafanExportGet = (
  exportId: number | undefined,
  queryOptions?: UseQueryOptions<IApiDatafanPipelineExport>,
) => {
  const queryClient = useQueryClient();
  const { i18n } = useLingui();
  const lang = i18n.locale === "ru" ? "ru" : "en";

  return useQuery<IApiDatafanPipelineExport>(
    [KEY, exportId],
    () =>
      ApiDatafanPipeline.Export.get({
        path: { id: exportId || 0 },
        query: { lang },
      }),
    {
      ...queryOptions,
      enabled:
        !!exportId &&
        (queryOptions?.enabled || queryOptions?.enabled === undefined),
      onSuccess: async (data) => {
        if (queryOptions?.refetchInterval && data.progress) {
          const progress = data.progress.items[data.progress.current_item_sign];

          if (
            progress.type === EApiDatafanProgressType.TIMER &&
            progress.current + 1 < progress.total
          ) {
            setTimeout(() => {
              if (data.progress) {
                queryClient.setQueryData([KEY, exportId], {
                  ...data,
                  progress: {
                    ...data.progress,
                    items: {
                      ...data.progress?.items,
                      [data.progress.current_item_sign]: {
                        ...progress,
                        current: progress.current + 1,
                      },
                    },
                  },
                });
              }
            }, 1000);
          }
        }

        if (queryOptions?.onSuccess) {
          queryOptions.onSuccess.apply(queryOptions, [data]);
        }
      },
    },
  );
};

useQueryDatafanExportGet.KEY = KEY;
